module.exports = __webpack_public_path__ + "static/media/detail_0023_f.76793c86.jpg";